import React, { useEffect, useState } from 'react'
import AuthService, { clearAuthLocalStorage } from '../features/auth/AuthService'
import windowLocationRedirect from '../features/redirect'
import { useLocation, useNavigate } from 'react-router-dom'
import UnauthorizedBlock from '../components/UnauthorizedBlock'

export default function Logout() {

    const navigate = useNavigate()

    const [message, setMessage] = useState<string>("")

     const { search } = useLocation()
    const parameters = new URLSearchParams(search)

    const backLink = parameters.get("back") 

    useEffect(() => {

        let link: string = ""

        if (backLink){
            link = "?back=" + backLink
        }

        AuthService.logout()
            .then(response => {
                // navigate("/")
                window.location.replace("/sign-in" + link)
            })
            .catch(error => {
                // navigate("/")
                window.location.replace("/sign-in" + link)
                setMessage(error.response.data.message ? error.response.data.message  : "Unknown Error")
            })

        clearAuthLocalStorage()
    }, [])

    return(
        <div>
            {/* {message && <h1 style={{ color: "red" }}>{message}</h1>} */}
            <UnauthorizedBlock title="Your session has been expired" message={message} />
        </div>
    )
}